import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { Checkbox } from '@dbk/ui-forms';
import { Large } from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import { PALETTE } from '../../../constants';

const ReportRMSelectAll = (props) => {
  const { i18n: { messages }, handleSelectAllClick, isSelectAllChecked, isSelectAllIndeterminate, showUnreadOnly, isShowUnreadOnlyChecked, handleShowUnreadOnlyClick } = props;
  return (
    <View className="checkboxRow" style={{ paddingLeft: 35 }} >
      <Checkbox
        className="checkboxClass"
        onChange={handleSelectAllClick}
        label={<Large numberOfLines={2} ellipsizeMode={'tail'} className="selectCheckBox" style={isSelectAllChecked ? { color: PALETTE.primaryActive } : { color: "#a7a8aa" }}>{messages['app.chedelivery.reports.selectAll']}</Large>}
        checked={isSelectAllChecked}
        indeterminate={isSelectAllIndeterminate}

      />

        <Checkbox
          checked={isShowUnreadOnlyChecked}
          className="checkboxClass"
          onChange={handleShowUnreadOnlyClick}
          label={<Large numberOfLines={2} ellipsizeMode={'tail'} className="selectCheckBox" style= { isShowUnreadOnlyChecked ? {color: PALETTE.primaryActive}  : { color:"#a7a8aa"}}>{messages['app.chedelivery.reports.showUnread']}</Large>}
        />

    </View>

  );
}

ReportRMSelectAll.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
    handleSelectAllClick: PropTypes.function,
    isSelectAllChecked: PropTypes.function,
    isSelectAllIndeterminate: PropTypes.function,
    showUnreadOnly: PropTypes.bool,
    isShowUnreadOnlyChecked: PropTypes.function,
    handleShowUnreadOnlyClick: PropTypes.function
  }),
};

ReportRMSelectAll.defaultProps = {
  i18n: {},
  handleSelectAllClick: '',
  isSelectAllChecked: '',
  isSelectAllIndeterminate: '',
  showUnreadOnly: '',
  isShowUnreadOnlyChecked: '',
  handleShowUnreadOnlyClick: ''
};

export default createContainer(
  {
    $queries: {
      i18n: {
        messages: true,
      },
    },
  },

)(ReportRMSelectAll);
